module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "external text-dark"
  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['external_view']))]), _vm._v(" "), _c('ul', {
    staticClass: "d-tabs"
  }, [_c('li', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.theActiveTab === 0
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveTab(0)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['calendars']) + "\n    ")]), _vm._v(" "), _c('li', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.theActiveTab === 1
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveTab(1)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['absent_today']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.theActiveTab === 1) ? [_c('h2', {
    staticClass: "marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_absent_today']))]), _vm._v(" "), _c('p', {
    staticClass: "marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_absent_today_desc']))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.absence
    }
  }, [_vm._v(_vm._s(_vm.absence))])] : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 0) ? [_c('h2', {
    staticClass: "marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules']))]), _vm._v(" "), _c('p', [(_vm.studentCalendars.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules_desc']) + ":")]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules_desc_with_students']) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "marg-1-top",
    attrs: {
      "href": _vm.publicLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.publicLink))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['use_update_in_url']))]), _vm._v(" "), (_vm.studentCalendars.length === 0) ? _c('h4', {
    staticClass: "marg-1-bottom marg-1-top"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['selected_the_schedules']))]) : _c('h4', {
    staticClass: "marg-1-bottom marg-1-top"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['selected_the_schedules_with_students']))]), _vm._v(" "), (_vm.isLoadingCalendars) ? _c('loader', {
    staticStyle: {
      "margin": "100px 200px"
    },
    attrs: {
      "bg-color": "#fff"
    }
  }) : _c('table', {
    staticClass: "d-table marg-2-top external__toggle-calendars"
  }, [_c('thead', {
    staticClass: "d-table__header"
  }, [_c('th'), _vm._v(" "), _c('th', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true
      }),
      expression: "{\n          arrow: true\n        }"
    }],
    staticClass: "inline-block",
    attrs: {
      "content": _vm.i18n[_vm.locale]['access_schedule_without_login']
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['visible_via_link']) + " "), _c('span', {
    staticClass: "icon-question3"
  })])]), _vm._v(" "), _c('th', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true
      }),
      expression: "{\n          arrow: true\n        }"
    }],
    staticClass: "inline-block text-link pointer",
    attrs: {
      "content": _vm.i18n[_vm.locale]['visible_via_link_tooltip']
    },
    on: {
      "click": function($event) {
        return _vm.setIsShowMobileGuide(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['schedules_on_desktop_mobile']) + " "), _c('span', {
    staticClass: "icon-question3"
  })])]), _vm._v(" "), _c('th', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true
      }),
      expression: "{\n          arrow: true\n        }"
    }],
    staticClass: "inline-block",
    attrs: {
      "content": _vm.i18n[_vm.locale]['schedules_on_desktop_mobile_tooltip']
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_schedules_until']) + " "), _c('span', {
    staticClass: "icon-question3"
  })])]), _vm._v(" "), _c('th', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true
      }),
      expression: "{\n      arrow: true\n    }"
    }],
    staticClass: "pointer inline-block text-link",
    attrs: {
      "content": _vm.i18n[_vm.locale]['integrations_with_google']
    },
    on: {
      "click": function($event) {
        return _vm.setIsShowICalGuide(true)
      }
    }
  }, [_vm._v("Google, Apple, Outlook "), _c('span', {
    staticClass: "icon-question3"
  })])])]), _vm._v(" "), _c('thead', {
    staticClass: "d-table__header d-table__header__first"
  }, [_c('th', {
    staticClass: "th-hover",
    on: {
      "click": function($event) {
        _vm.isShowKlass = !_vm.isShowKlass
      }
    }
  }, [_c('span', {
    staticClass: "marg-1-right",
    class: [{
      'icon-arrow-up': _vm.isShowKlass
    }, {
      'icon-arrow-down': !_vm.isShowKlass
    }]
  }), _vm._v("\n          " + _vm._s(_vm.calendarsWithProps.length) + "\n          " + _vm._s(_vm.calendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['grade'] : _vm.i18n[_vm.locale]['grades']) + "\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "toggle-all-calendars"
  }, [(_vm.isShowKlass) ? [(_vm.isToggleLoading === 'klass') ? _c('loader', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "isExtraSmall": true,
      "bg-color": "#f6f9fc"
    }
  }) : _c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleAllKlassCalendars.apply(null, arguments)
      }
    }
  }, [(_vm.isAnyKlassCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowKlass) ? _c('tbody', [(_vm.calendarsWithProps.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-explainer",
    staticStyle: {
      "padding": "8px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_grades_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendarsWithProps), function(calendar) {
    return [_c('tr', {
      key: calendar.id,
      class: {
        'tr-calendar--is-open': calendar.v_is_open
      }
    }, [_c('td', {
      class: {
        'name-and-toggle': calendar.students && calendar.students.length > 0
      },
      on: {
        "click": function($event) {
          return _vm.setActiveKlassCalendar(calendar)
        }
      }
    }, [(calendar.students && calendar.students.length > 0) ? _c('div', {
      staticClass: "d-toggle-arrow"
    }) : _vm._e(), _vm._v("\n              " + _vm._s(calendar.name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      on: {
        "click": function($event) {
          return _vm.toggleAnonymousAccess(calendar)
        }
      }
    }, [_c('app-toggle', {
      attrs: {
        "prop-on": calendar.anonymous_access,
        "allow-changes": false
      }
    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_public_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "400px"
      }
    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__no-end-date"
    }, [_c('p', {
      staticClass: "text-explainer"
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('div', {
      staticClass: "icon__bg-circle"
    }, [_c('span', {
      staticClass: "icon-calendar4"
    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container"
    }, [_c('DateSelector', {
      staticStyle: {
        "width": "210px"
      },
      attrs: {
        "date": _vm.theActiveDatePickerDate,
        "isOpen": true
      },
      on: {
        "changed": function($event) {
          return _vm.updatePublishUntilDate(calendar, $event)
        },
        "close": function($event) {
          return _vm.closeDatepicker(calendar)
        }
      }
    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
      on: {
        "click": function($event) {
          return _vm.deleteActiveDatePicker(calendar)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
    }, [_c('div', {
      staticClass: "datepicker-input pointer pos-relative",
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (calendar.v_formatted_date),
        expression: "calendar.v_formatted_date"
      }],
      attrs: {
        "id": "inputfield",
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (calendar.v_formatted_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(calendar, "v_formatted_date", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-calendar4 input-icon"
    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_ical_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n              ")])])]), _vm._v(" "), (calendar.v_is_open) ? _c('tr', {
      staticClass: "tr-student--tr-thead d-table__header"
    }, [_c('th', [_vm._v(_vm._s(_vm.activeStudentCalenders.length) + " "), (_vm.activeStudentCalenders.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['student']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['students']))])]), _vm._v(" "), _c('th', {
      staticClass: "toggle-all-calendars"
    }, [(_vm.isToggleLoading === 'students') ? _c('loader', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "isExtraSmall": true,
        "bg-color": "#f6f9fc"
      }
    }) : _c('div', {
      staticClass: "inline-block pointer",
      on: {
        "click": _vm.toggleAllStudentCalendars
      }
    }, [(_vm.isAnyActiveStudentCalendersWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n              ")])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeStudentCalenders), function(student, key) {
      return (calendar.v_is_open) ? _c('tr', {
        key: student.id,
        staticClass: "tr-student--tr",
        class: {
          'tr-student--tr-thead--first': _vm.activeStudentCalenders.length > 1 && key === 0
        }
      }, [_c('td', [_vm._v("\n              " + _vm._s(student.name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "inline-block",
        on: {
          "click": function($event) {
            return _vm.toggleAnonymousAccess(student)
          }
        }
      }, [_c('app-toggle', {
        attrs: {
          "prop-on": student.anonymous_access,
          "allow-changes": false
        }
      })], 1)]), _vm._v(" "), _c('td', [(student.anonymous_access) ? _c('button', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            onShow: _vm.hideTippy,
            trigger: 'manual',
            arrow: true,
            placement: 'top',
            zIndex: 2147483010
          }),
          expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
        }],
        staticClass: "bttn bttn--white bttn--small",
        attrs: {
          "content": _vm.i18n[_vm.locale]['copied'] + ' ' + student.v_public_link
        },
        on: {
          "click": function($event) {
            return _vm.copyToClipboard(student.v_public_link, $event)
          }
        }
      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "400px"
        }
      }, [(!student.published_until && _vm.theActiveDatePickerId !== student.id) ? _c('div', {
        staticClass: "calendar__no-end-date"
      }, [_c('p', {
        staticClass: "text-explainer"
      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
        staticClass: "hint--right",
        attrs: {
          "aria-label": _vm.i18n[_vm.locale]['set_a_date']
        },
        on: {
          "click": function($event) {
            return _vm.setActiveDatePicker(student)
          }
        }
      }, [_c('div', {
        staticClass: "icon__bg-circle"
      }, [_c('span', {
        staticClass: "icon-calendar4"
      })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === student.id) ? _c('div', {
        staticClass: "calendar__datepicker-container"
      }, [_c('DateSelector', {
        staticStyle: {
          "width": "210px"
        },
        attrs: {
          "date": _vm.theActiveDatePickerDate,
          "isOpen": true
        },
        on: {
          "changed": function($event) {
            return _vm.updatePublishUntilDate(student, $event)
          },
          "close": function($event) {
            return _vm.closeDatepicker(student)
          }
        }
      }), _vm._v(" "), (student.published_until) ? _c('button', {
        staticClass: "bttn bttn-danger calendar__datepicker-container__button",
        on: {
          "click": function($event) {
            return _vm.deleteActiveDatePicker(student)
          }
        }
      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (student.published_until && _vm.theActiveDatePickerId !== student.id) ? _c('div', {
        staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
      }, [_c('div', {
        staticClass: "datepicker-input pointer pos-relative",
        on: {
          "click": function($event) {
            return _vm.setActiveDatePicker(student)
          }
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (student.v_formatted_date),
          expression: "student.v_formatted_date"
        }],
        attrs: {
          "type": "text",
          "readonly": ""
        },
        domProps: {
          "value": (student.v_formatted_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(student, "v_formatted_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "icon-calendar4 input-icon"
      })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            onShow: _vm.hideTippy,
            trigger: 'manual',
            arrow: true,
            placement: 'top',
            zIndex: 2147483010
          }),
          expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
        }],
        staticClass: "bttn bttn--white bttn--small",
        attrs: {
          "content": _vm.i18n[_vm.locale]['copied'] + ' ' + student.v_ical_link
        },
        on: {
          "click": function($event) {
            return _vm.copyToClipboard(student.v_ical_link, $event)
          }
        }
      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n              ")])])]) : _vm._e()
    })]
  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
    staticClass: "d-table__header d-table__header__first"
  }, [_c('th', {
    staticClass: "th-hover",
    on: {
      "click": function($event) {
        _vm.isShowRooms = !_vm.isShowRooms
      }
    }
  }, [_c('span', {
    staticClass: "marg-1-right",
    class: [{
      'icon-arrow-up': _vm.isShowRooms
    }, {
      'icon-arrow-down': !_vm.isShowRooms
    }]
  }), _vm._v("\n          " + _vm._s(_vm.roomCalendarsWithProps.length) + "\n          " + _vm._s(_vm.roomCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['rooms'] : _vm.i18n[_vm.locale]['room']) + "\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "toggle-all-calendars"
  }, [(_vm.isShowRooms) ? [(_vm.isToggleLoading === 'rooms') ? _c('loader', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "isExtraSmall": true,
      "bg-color": "#f6f9fc"
    }
  }) : _c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleAllRoomCalendars.apply(null, arguments)
      }
    }
  }, [(_vm.isAnyRoomCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowRooms) ? _c('tbody', [(_vm.roomCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-explainer",
    staticStyle: {
      "padding": "8px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_rooms_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.roomCalendarsWithProps), function(calendar) {
    return _c('tr', {
      key: calendar.id
    }, [_c('td', [_c('span', {
      staticClass: "icon-location"
    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      on: {
        "click": function($event) {
          return _vm.toggleAnonymousAccess(calendar)
        }
      }
    }, [_c('app-toggle', {
      attrs: {
        "prop-on": calendar.anonymous_access,
        "allow-changes": false
      }
    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_public_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "400px"
      }
    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__no-end-date"
    }, [_c('p', {
      staticClass: "text-explainer"
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('div', {
      staticClass: "icon__bg-circle"
    }, [_c('span', {
      staticClass: "icon-calendar4"
    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container"
    }, [_c('DateSelector', {
      staticStyle: {
        "width": "210px"
      },
      attrs: {
        "date": _vm.theActiveDatePickerDate,
        "isOpen": true
      },
      on: {
        "changed": function($event) {
          return _vm.updatePublishUntilDate(calendar, $event)
        },
        "close": function($event) {
          return _vm.closeDatepicker(calendar)
        }
      }
    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
      on: {
        "click": function($event) {
          return _vm.deleteActiveDatePicker(calendar)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
    }, [_c('div', {
      staticClass: "datepicker-input pointer pos-relative",
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (calendar.v_formatted_date),
        expression: "calendar.v_formatted_date"
      }],
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (calendar.v_formatted_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(calendar, "v_formatted_date", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-calendar4 input-icon"
    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_ical_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
    staticClass: "d-table__header d-table__header__first"
  }, [_c('th', {
    staticClass: "th-hover",
    on: {
      "click": function($event) {
        _vm.isShowUsers = !_vm.isShowUsers
      }
    }
  }, [_c('span', {
    staticClass: "marg-1-right",
    class: [{
      'icon-arrow-up': _vm.isShowUsers
    }, {
      'icon-arrow-down': !_vm.isShowUsers
    }]
  }), _vm._v("\n          " + _vm._s(_vm.userCalendarsWithProps.length) + "\n          " + _vm._s(_vm.userCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['users'] : _vm.i18n[_vm.locale]['user']) + "\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "toggle-all-calendars"
  }, [(_vm.isShowUsers) ? [(_vm.isToggleLoading === 'users') ? _c('loader', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "isExtraSmall": true,
      "bg-color": "#f6f9fc"
    }
  }) : _c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleAllUsersCalendars.apply(null, arguments)
      }
    }
  }, [(_vm.isAnyUserCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowUsers) ? _c('tbody', [(_vm.userCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-explainer",
    staticStyle: {
      "padding": "8px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userCalendarsWithProps), function(calendar) {
    return _c('tr', {
      key: calendar.id
    }, [_c('td', [_c('span', {
      staticClass: "icon-location"
    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      on: {
        "click": function($event) {
          return _vm.toggleAnonymousAccess(calendar)
        }
      }
    }, [_c('app-toggle', {
      attrs: {
        "prop-on": calendar.anonymous_access,
        "allow-changes": false
      }
    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_public_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "400px"
      }
    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__no-end-date"
    }, [_c('p', {
      staticClass: "text-explainer"
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('div', {
      staticClass: "icon__bg-circle"
    }, [_c('span', {
      staticClass: "icon-calendar4"
    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container"
    }, [_c('DateSelector', {
      staticStyle: {
        "width": "210px"
      },
      attrs: {
        "date": _vm.theActiveDatePickerDate,
        "isOpen": true
      },
      on: {
        "changed": function($event) {
          return _vm.updatePublishUntilDate(calendar, $event)
        },
        "close": function($event) {
          return _vm.closeDatepicker(calendar)
        }
      }
    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
      on: {
        "click": function($event) {
          return _vm.deleteActiveDatePicker(calendar)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
    }, [_c('div', {
      staticClass: "datepicker-input pointer pos-relative",
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (calendar.v_formatted_date),
        expression: "calendar.v_formatted_date"
      }],
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (calendar.v_formatted_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(calendar, "v_formatted_date", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-calendar4 input-icon"
    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_ical_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
    staticClass: "d-table__header d-table__header__first"
  }, [_c('th', {
    staticClass: "th-hover",
    on: {
      "click": function($event) {
        _vm.isShowMergeCalendars = !_vm.isShowMergeCalendars
      }
    }
  }, [_c('span', {
    staticClass: "marg-1-right",
    class: [{
      'icon-arrow-up': _vm.isShowMergeCalendars
    }, {
      'icon-arrow-down': !_vm.isShowMergeCalendars
    }]
  }), _vm._v("\n          " + _vm._s(_vm.mergeCalendarsWithProps.length) + "\n          " + _vm._s(_vm.mergeCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['merge_calendars'] : _vm.i18n[_vm.locale]['merge_calendar']) + "\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "toggle-all-calendars"
  }, [(_vm.isShowMergeCalendars) ? [(_vm.isToggleLoading === 'merge') ? _c('loader', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "isExtraSmall": true,
      "bg-color": "#f6f9fc"
    }
  }) : _c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleAllMergeCalendars.apply(null, arguments)
      }
    }
  }, [(_vm.isAnyMergeCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowMergeCalendars) ? _c('tbody', [(_vm.mergeCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-explainer",
    staticStyle: {
      "padding": "8px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_merge_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mergeCalendarsWithProps), function(calendar) {
    return _c('tr', {
      key: calendar.id
    }, [_c('td', [_c('span', {
      staticClass: "icon-clipboard2"
    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      on: {
        "click": function($event) {
          return _vm.toggleAnonymousAccess(calendar)
        }
      }
    }, [_c('app-toggle', {
      attrs: {
        "prop-on": calendar.anonymous_access,
        "allow-changes": false
      }
    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_public_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "400px"
      }
    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__no-end-date"
    }, [_c('p', {
      staticClass: "text-explainer"
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('div', {
      staticClass: "icon__bg-circle"
    }, [_c('span', {
      staticClass: "icon-calendar4"
    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container"
    }, [_c('DateSelector', {
      staticStyle: {
        "width": "210px"
      },
      attrs: {
        "date": _vm.theActiveDatePickerDate,
        "isOpen": true
      },
      on: {
        "changed": function($event) {
          return _vm.updatePublishUntilDate(calendar, $event)
        },
        "close": function($event) {
          return _vm.closeDatepicker(calendar)
        }
      }
    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
      on: {
        "click": function($event) {
          return _vm.deleteActiveDatePicker(calendar)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
    }, [_c('div', {
      staticClass: "datepicker-input pointer pos-relative",
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (calendar.v_formatted_date),
        expression: "calendar.v_formatted_date"
      }],
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (calendar.v_formatted_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(calendar, "v_formatted_date", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-calendar4 input-icon"
    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_ical_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
    staticClass: "d-table__header d-table__header__first"
  }, [_c('th', {
    staticClass: "th-hover",
    on: {
      "click": function($event) {
        _vm.isShowOtherCalendars = !_vm.isShowOtherCalendars
      }
    }
  }, [_c('span', {
    staticClass: "marg-1-right",
    class: [{
      'icon-arrow-up': _vm.isShowOtherCalendars
    }, {
      'icon-arrow-down': !_vm.isShowOtherCalendars
    }]
  }), _vm._v("\n          " + _vm._s(_vm.otherCalendarsWithProps.length) + "\n          " + _vm._s(_vm.otherCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['other'] : _vm.i18n[_vm.locale]['other']) + "\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "toggle-all-calendars"
  }, [(_vm.isShowOtherCalendars) ? [(_vm.isToggleLoading === 'other') ? _c('loader', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "isExtraSmall": true,
      "bg-color": "#f6f9fc"
    }
  }) : _c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleAllOtherCalendars.apply(null, arguments)
      }
    }
  }, [(_vm.isAnyOtherCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowOtherCalendars) ? _c('tbody', [(_vm.otherCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-explainer",
    staticStyle: {
      "padding": "8px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_other_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.otherCalendarsWithProps), function(calendar) {
    return _c('tr', {
      key: calendar.id
    }, [_c('td', [_c('span', {
      staticClass: "icon-clipboard2"
    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      on: {
        "click": function($event) {
          return _vm.toggleAnonymousAccess(calendar)
        }
      }
    }, [_c('app-toggle', {
      attrs: {
        "prop-on": calendar.anonymous_access,
        "allow-changes": false
      }
    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_public_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "400px"
      }
    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__no-end-date"
    }, [_c('p', {
      staticClass: "text-explainer"
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('div', {
      staticClass: "icon__bg-circle"
    }, [_c('span', {
      staticClass: "icon-calendar4"
    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container"
    }, [_c('DateSelector', {
      staticStyle: {
        "width": "210px"
      },
      attrs: {
        "date": _vm.theActiveDatePickerDate,
        "isOpen": true
      },
      on: {
        "changed": function($event) {
          return _vm.updatePublishUntilDate(calendar, $event)
        },
        "close": function($event) {
          return _vm.closeDatepicker(calendar)
        }
      }
    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
      on: {
        "click": function($event) {
          return _vm.deleteActiveDatePicker(calendar)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
    }, [_c('div', {
      staticClass: "datepicker-input pointer pos-relative",
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (calendar.v_formatted_date),
        expression: "calendar.v_formatted_date"
      }],
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (calendar.v_formatted_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(calendar, "v_formatted_date", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-calendar4 input-icon"
    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_ical_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
    staticClass: "d-table__header d-table__header__first"
  }, [_c('th', {
    staticClass: "th-hover",
    on: {
      "click": function($event) {
        _vm.isShowClubCalendars = !_vm.isShowClubCalendars
      }
    }
  }, [_c('span', {
    staticClass: "marg-1-right",
    class: [{
      'icon-arrow-up': _vm.isShowClubCalendars
    }, {
      'icon-arrow-down': !_vm.isShowClubCalendars
    }]
  }), _vm._v("\n          " + _vm._s(_vm.clubCalendarsWithProps.length) + "\n          " + _vm._s(_vm.clubCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['club'] : _vm.i18n[_vm.locale]['club']) + "\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "toggle-all-calendars"
  }, [(_vm.isShowClubCalendars) ? [(_vm.isToggleLoading === 'club') ? _c('loader', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "isExtraSmall": true,
      "bg-color": "#f6f9fc"
    }
  }) : _c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleAllClubCalendars.apply(null, arguments)
      }
    }
  }, [(_vm.isAnyClubCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowClubCalendars) ? _c('tbody', [(_vm.clubCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-explainer",
    staticStyle: {
      "padding": "8px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_club_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.clubCalendarsWithProps), function(calendar) {
    return _c('tr', {
      key: calendar.id
    }, [_c('td', [_c('span', {
      staticClass: "icon-clipboard2"
    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      on: {
        "click": function($event) {
          return _vm.toggleAnonymousAccess(calendar)
        }
      }
    }, [_c('app-toggle', {
      attrs: {
        "prop-on": calendar.anonymous_access,
        "allow-changes": false
      }
    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_public_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "400px"
      }
    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__no-end-date"
    }, [_c('p', {
      staticClass: "text-explainer"
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('div', {
      staticClass: "icon__bg-circle"
    }, [_c('span', {
      staticClass: "icon-calendar4"
    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container"
    }, [_c('DateSelector', {
      staticStyle: {
        "width": "210px"
      },
      attrs: {
        "date": _vm.theActiveDatePickerDate,
        "isOpen": true
      },
      on: {
        "changed": function($event) {
          return _vm.updatePublishUntilDate(calendar, $event)
        },
        "close": function($event) {
          return _vm.closeDatepicker(calendar)
        }
      }
    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
      on: {
        "click": function($event) {
          return _vm.deleteActiveDatePicker(calendar)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
    }, [_c('div', {
      staticClass: "datepicker-input pointer pos-relative",
      on: {
        "click": function($event) {
          return _vm.setActiveDatePicker(calendar)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (calendar.v_formatted_date),
        expression: "calendar.v_formatted_date"
      }],
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (calendar.v_formatted_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(calendar, "v_formatted_date", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-calendar4 input-icon"
    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
      }],
      staticClass: "bttn bttn--white bttn--small",
      attrs: {
        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
      },
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(calendar.v_ical_link, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
  })], 2) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), _c('export-calendar', {
    attrs: {
      "isShowButton": false,
      "isShowFromProp": _vm.isShowICalGuide
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowICalGuide(false)
      }
    }
  }), _vm._v(" "), _c('CalendarOnMobileGuides', {
    attrs: {
      "isShowFromProp": _vm.isShowMobileGuide
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowMobileGuide(false)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f88a6a9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/ExternalCalendars.vue
// module id = 1509
// module chunks = 1